export default __webpack_public_path__ + "static/media/1.0671b606.png";